import React from 'react';
import Form from '../../../common/form/Form';
import { SCOPES } from '../../../../constants/scopes.constants';
import ThresholdCard from './elements/ThresholdCard';
import DoubleDipCapCard from './elements/DoubleDipCapCard';
import AdvancedBalanceConfigCard from './elements/AdvancedBalanceConfigCard';
import styles from './styles/availableBalanceForm.module.scss';

function AvailableBalanceForm({
    values = {},
    rules = {},
    options = {},
    enabled = {},
    handlers = {},
    onCancel,
    onSubmit,
    loading,
    disabledSave,
    submitText,
    confirmBeforeSubmit = false,
    readOnly = false,
}) {
    return (
        <Form
            onSubmit={onSubmit}
            loading={loading}
            disabled={disabledSave}
            onCancel={onCancel}
            confirmBeforeSubmit={confirmBeforeSubmit}
            submitText={loading ? 'Saving...' : (submitText ?? 'Save')}
            readOnly={readOnly}
            submitGuardScope={SCOPES.CONFIGURATIONS_MANAGE}
        >
            <div className={styles.formRoot}>
                <div className={styles.topCardsGrid}>
                    <ThresholdCard value={values.threshold} onChange={handlers.setThreshold} />
                    <DoubleDipCapCard
                        value={values.doubleDipCap}
                        enabled={enabled.doubleDipCap}
                        onChange={handlers.setDoubleDipCap}
                        onToggleEnabled={handlers.toggleDoubleDipCap}
                    />
                </div>
                <AdvancedBalanceConfigCard rules={rules} options={options} handlers={handlers} />
            </div>
        </Form>
    );
}

export default AvailableBalanceForm;
